angular
  .module('ui-ng-feature')
  .constant('phxFeatureDatastore', {
    store: {}
  })
  .provider('phxFeatureConfiguration', [
    'phxFeatureDatastore',
    function phxFeatureConfigurationProvider(phxFeatureDatastore) {
      const features =
        (this.features =
        this.write =
          function features_phxFeatureConfiguration(appendFeatureConfiguration) {
            if (_.isPlainObject(appendFeatureConfiguration)) {
              phxFeatureDatastore.store = _.merge(phxFeatureDatastore.store, appendFeatureConfiguration);
            }

            return phxFeatureDatastore.store;
          });

      /**
       * @param o the object to scrub
       * @param featureKey the feature to use
       * @param searchTerm the word to search for
       */
      const scrub = (this.scrub = function (o, featureKey, searchTerm) {
        const searchRegex = !_.isRegExp(searchTerm) ? new RegExp(searchTerm, 'g') : searchTerm;

        const feature = phxFeatureDatastore.store[featureKey];

        if (!feature) {
          return o;
        }

        const alterationRule = feature.include === false ? '' : feature.assignContent || '';

        return traverse(o, (value) => {
          if (!_.isString(value)) {
            return value;
          }

          if (!value.match(searchRegex)) {
            return value;
          }

          return value.split(searchRegex).join(alterationRule);
        });
      });

      const traverse = (o, fn) => {
        if (!_.isObject(o)) {
          return fn(o);
        }

        _.each(o, (v, k, o) => {
          o[k] = _.isObject(v) ? traverse(v, fn) : fn(v, k);
        });

        return o;
      };

      const read = (this.read = function read_phxFeatureConfiguration(featureKey) {
        return phxFeatureDatastore.store[featureKey];
      });

      const safeRead = (this.safeRead = function safeRead_phxFeatureConfiguration(featureKey) {
        return phxFeatureDatastore.store[featureKey] || {};
      });

      const reset = (this.reset = function reset_phxFeatureConfiguration() {
        phxFeatureDatastore.store = {};
        return phxFeatureDatastore.store;
      });

      this.$get = function phxFeatureConfigurationGetter(phxFeature) {
        return {
          scrub: function (o, featureKey, searchTerm) {
            return scrub(o, featureKey, searchTerm);
          },
          features: function (appendFeatureConfiguration) {
            features(appendFeatureConfiguration);
            phxFeature.refreshFeatures();
          },
          read: function (featureKey) {
            return read(featureKey);
          },
          safeRead: function (featureKey) {
            return safeRead(featureKey);
          },
          reset: function () {
            reset();
            phxFeature.refreshFeatures();
          }
        };
      };
    }
  ]);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-feature/src/service.es.js